import { Gapped } from "react-ui";
import * as React from "react";

import { FormSettings } from "../../../../../Forms/Types/FormSettings";
import { ActionButtonContainer } from "../../../ActionButton/ActionButtonContainer";
import { ActionPanelButtonWidth } from "../../PanelTypes";
import { SendActionButtonContainer } from "../../../ActionButton/SendActionButtonContainer";

interface ActionPanelFormActionsProps {
    formSettings: FormSettings;
    checkErrors: () => void;
}

export const ActionPanelFormActions = (props: ActionPanelFormActionsProps) => {
    if (props.formSettings.isReadOnly) {
        return <></>;
    }

    if (props.formSettings.embeddedLogEnabled) {
        return (
            <Gapped>
                <ActionButtonContainer
                    onCheckErrors={props.checkErrors}
                    place="menu"
                    type="check"
                    width={ActionPanelButtonWidth.middleSize1}
                />
                {!props.formSettings.isDisabledCloseButton && (
                    <ActionButtonContainer
                        place="menu"
                        type="close"
                        use="default"
                        width={ActionPanelButtonWidth.smallSize}
                    />
                )}
            </Gapped>
        );
    }

    if (props.formSettings.allowsend || props.formSettings.isFormInFormNds) {
        return (
            <Gapped vertical>
                <SendActionButtonContainer
                    place="menu"
                    text="Проверить и отправить"
                    width={ActionPanelButtonWidth.largeSize}
                />
                {!props.formSettings.isDisabledCloseButton && (
                    <ActionButtonContainer
                        place="menu"
                        type="close"
                        use="default"
                        width={ActionPanelButtonWidth.largeSize}
                    />
                )}
            </Gapped>
        );
    }

    if (!props.formSettings.isDisabledCloseAndSaveButton) {
        return <ActionButtonContainer place="menu" type="save" width={ActionPanelButtonWidth.largeSize} />;
    }

    return null;
};
